<template>
    <v-container>
        <div v-if="current_role == 'student' && afterMounted == true">
            This section for Employees
        </div>
        <div v-else>
        <v-row>
            <v-col>
        <h1>Personal Information</h1>
        
        <p>Please ensure the information below is accurate and up to date. Of the information listed below, only your preferred name and pronoun preference will be displayed on the Adelphi website's public directory. <strong>If you have any questions or edits, please contact <a class="bold-link" href="https://hr.adelphi.edu/contact/" target="_blank">Human Resources.</a></strong></p>
            </v-col>
        </v-row>
        <div v-if="afterMounted == true">
        <v-row>
            <v-col cols="12" sm="3">
                  <span class="label" aria-labelledby="LegalName">Legal Name</span>
            </v-col>
            <v-col cols="12" sm="9">
               <span id="LegalName" class="black-text">{{ this.personal_data.Legal_Name }}</span>
                <v-tooltip right v-model="show_tooltip_legal_name" max-width="300px">
                <template v-slot:activator="{}">
                    <v-btn v-click-outside="hide_legal_name" @click="showTooltip('legal_name')" icon aria-label="More information">
                        <v-icon>info</v-icon>
                    </v-btn>
                </template>
                <span>{{ this.tooltips.legal_name }}</span>
            </v-tooltip>
            </v-col>
        </v-row>
     
        <v-row>
            <v-col cols="12">
                <v-checkbox v-model="show_preferred_name" label="My preferred name differs from my legal name." />
            </v-col>
        </v-row>
        <div v-if="show_preferred_name === true">
        
        <h2>
            Preferred Name
<v-tooltip right v-model="show_tooltip_preferred_name" max-width="300px">
                <template v-slot:activator="{}">
                    <v-btn v-click-outside="hide_preferred_name" @click="showTooltip('preferred_name')" icon aria-label="Preferred Name Info">
                        <v-icon>info</v-icon>
                    </v-btn>
                </template>
                <span>{{ this.tooltips.preferred_name }}</span>
            </v-tooltip>
        </h2>
        <v-row>
            <v-col cols="12">
        <p>Please note these fields are case sensitive. Type your name exactly how it should appear in the directory.</p>
        <p>Please email <a class="bold-link" href="mailto:helpdesk@adelphi.edu">helpdesk@adelphi.edu</a> if you would also like to change your login/email address.</p>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Prefix</v-label>
            </v-col>
            <v-col cols="12" sm="2">
                <v-select v-model="preferred_prefix" outlined aria-label="Prefix" clearable :items="prefixes" :value="this.personal_data.Preferred_Prefix" />
            </v-col>
        </v-row> -->
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">First Name</v-label>
            </v-col>
            <v-col cols="12" sm="9">
                <v-text-field outlined v-model="preferred_first" aria-label="First Name" :value="this.personal_data.Preferred_First" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Middle Initial</v-label>
            </v-col>
            <v-col cols="12" sm="1">
                <v-text-field outlined v-model="preferred_middle" aria-label="Middle Initial" :value="this.personal_data.Preferred_Middle" maxlength="1" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Last Name</v-label>
            </v-col>
            <v-col cols="12" sm="9">
                <v-text-field outlined v-model="preferred_last" aria-label="Last Name" :value="this.personal_data.Preferred_Last" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Suffix</v-label>
            </v-col>
            <v-col cols="12" sm="2">
                <v-select v-model="preferred_suffix" outlined aria-label="Suffix" clearable :items="suffixes" :value="this.personal_data.Preferred_Suffix" />
            </v-col>
        </v-row>
        
        <!-- <v-checkbox label="Change my username (email will be changed as well)" /> -->
        <v-checkbox v-model="preferred_mailing" label="Use my preferred name in mailings" />
        </div>
        <div>
        <v-row>
            <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="DOB">Date of Birth</span>
            </v-col>
            <v-col cols="12" sm="9">
                <span id="DOB" class="black-text">{{ this.personal_data.Date_of_Birth }}</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <span class="label" aria-labelledby="MaritalStatus">Marital Status</span>
            </v-col>
            <v-col cols="12" sm="9">
                <span id="MaritalStatus" class="black-text">{{ this.personal_data.Marital_Status }}</span>
            </v-col>
        </v-row>

        <h2>Phone</h2>
        <p>Your personal phone numbers will never be used in the public directory.</p>
        <v-row>
            <v-col cols="12" sm="3">
                 <v-label aria-hidden="true">Home Phone</v-label>
            </v-col>
            <v-col cols="12" sm="3">
                <v-text-field v-model="home_phone" v-mask="mask" outlined aria-label="Home Phone" :value="this.personal_data.Home_Number" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Cell Phone</v-label>
            </v-col>
            <v-col cols="12" sm="3">
                <v-text-field v-model="cell_phone" v-mask="mask" outlined aria-label="Cell Phone" :value="this.personal_data.Mobile_Number" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
        
            </v-col>
        </v-row>

        <h2>Home Address</h2>
         <p>Your address will never be used in the public directory.</p>
                
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Street Address</v-label>
            </v-col>
            <v-col cols="12" sm="9">
                <v-text-field v-model="address1" outlined aria-label="Street Address" :value="this.personal_data.Street_Address" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Address Line 2</v-label>
            </v-col>
            <v-col cols="12" sm="9">
                <v-text-field v-model="address2" outlined aria-label="Address Line 2" :value="this.personal_data.Address_Line_2" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">City</v-label>
            </v-col>
            <v-col cols="12" sm="9">
                <v-text-field v-model="city" outlined aria-label="City" :value="this.personal_data.City" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">State</v-label>
            </v-col>
            <v-col cols="12" sm="3">
                <v-autocomplete v-model="selected_state" aria-label="State" outlined clearable :items="states" item-value="PK" item-text="Description" :value="this.personal_data.State" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">ZIP/Postal Code</v-label>
            </v-col>
            <v-col cols="12" sm="3">
                <v-text-field v-mask="'#####'" v-model="zip_code" outlined aria-label="ZIP/Postal Code" :value="this.personal_data.Zip" />
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12" sm="3">
                <v-label aria-hidden="true">Country</v-label>
            </v-col>
            <v-col cols="12" sm="9">
                <v-autocomplete v-model="selected_country" aria-label="Country" outlined clearable :items="country" :value="this.personal_data.Country" />
            </v-col>
        </v-row> -->
        </div>
        <v-container>
            <h2>Emergency Contact</h2>
            <v-row>
                <v-col cols="12" sm="3">
                    <v-label aria-hidden="true">Full Name</v-label>
                </v-col>
                <v-col cols="12" sm="9">
                    <v-text-field outlined v-model="emergency_name" aria-label="Emergency Contact Full Name" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <v-label aria-hidden="true">Relationship</v-label>
                </v-col>
                <v-col cols="12" sm="9">
                    <v-text-field outlined v-model="emergency_relationship" aria-label="Emergency Contact Relationship" />
                </v-col>
            </v-row>
            <!-- <v-row>
                <v-col cols="12" sm="3">
                    <v-label aria-hidden="true">Last Name</v-label>
                </v-col>
                <v-col cols="12" sm="9">
                    <v-text-field outlined aria-label="Emergency Contact Last Name" />
                </v-col>
            </v-row> -->
            <v-row>
                <v-col cols="12" sm="3">
                    <v-label aria-hidden="true">Phone</v-label>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field outlined v-mask="mask" v-model="emergency_phone" aria-label="Emergency Contact Phone" />
                </v-col>
            </v-row>
        </v-container>

        <!-- Conditionally show if user is not in Rave -->
        <!-- <v-container>
            <v-checkbox v-model="rave_signup" :disabled="rave_signup" label="Sign up for Rave Alert mass notification system to be notified if there is an emergency or campus closure." />
        </v-container> -->
        <!-- End Conditional -->
        
        <v-container>
            <h2>Voluntary Information</h2>
            <p>The information requested below is compiled for reporting purposes only, and will not be utilized to make any employment decisions.</p>
            <h3 class="label">Race/Ethnicity</h3>
            <div class="flexbox">
                <v-checkbox label="Hispanic or Latino" value="H" v-model="eth" :disabled="this.personal_data.Race_Ethnicity_MV.Race_Ethnicity > 1 || this.personal_data.Race_Ethnicity_MV.Race_Ethnicity != null" />
            
                <v-tooltip right v-model="show_tooltip_hispanic" max-width="300px">
                    <template v-slot:activator="{}">
                        <v-btn v-click-outside="hide_hispanic" @click="showTooltip('hispanic')" icon aria-label="More information">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ this.tooltips.hispanic }}</span>
                </v-tooltip>
            </div>
            <div class="flexbox">
                <v-checkbox label="Asian" value="A" v-model="eth" :disabled="this.personal_data.Race_Ethnicity_MV.Race_Ethnicity > 1 || this.personal_data.Race_Ethnicity_MV.Race_Ethnicity != null" />
                <v-tooltip right v-model="show_tooltip_asian" max-width="300px">
                    <template v-slot:activator="{}">
                        <v-btn v-click-outside="hide_asian" @click="showTooltip('asian')" icon aria-label="More information">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ this.tooltips.asian }}</span>
                </v-tooltip>
            </div>
            <div class="flexbox">
                <v-checkbox label="Black or African American" value="B" v-model="eth" :disabled="this.personal_data.Race_Ethnicity_MV.Race_Ethnicity > 1 || this.personal_data.Race_Ethnicity_MV.Race_Ethnicity != null" />
                
                <v-tooltip right v-model="show_tooltip_black" max-width="300px">
                    <template v-slot:activator="{}">
                        <v-btn v-click-outside="hide_black" @click="showTooltip('black')" icon aria-label="More information">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ this.tooltips.black }}</span>
                </v-tooltip>
            </div>
            <div class="flexbox">
                <v-checkbox label="Native Hawaiian or Other Pacific Islander" value="P" v-model="eth" :disabled="this.personal_data.Race_Ethnicity_MV.Race_Ethnicity > 1 || this.personal_data.Race_Ethnicity_MV.Race_Ethnicity != null" />
                <v-tooltip right v-model="show_tooltip_pacific" max-width="300px">
                    <template v-slot:activator="{}">
                        <v-btn v-click-outside="hide_pacific" @click="showTooltip('pacific')" icon aria-label="More information">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ this.tooltips.pacific }}</span>
                </v-tooltip>
            </div>
            <div style="display: flex; align-items: center;">
            <v-checkbox label="Indigenous Peoples of the Americas" value="I" v-model="eth" :disabled="this.personal_data.Race_Ethnicity_MV.Race_Ethnicity > 1 || this.personal_data.Race_Ethnicity_MV.Race_Ethnicity != null" />
            <v-tooltip right v-model="show_tooltip_indigenous" max-width="300px">
                <template v-slot:activator="{}">
                    <v-btn v-click-outside="hide_indigenous" @click="showTooltip('indigenous')" icon aria-label="More information" style="display: inline;">
                        <v-icon>info</v-icon>
                    </v-btn>
                </template>
                <span>{{ this.tooltips.indigenous }}</span>
            </v-tooltip>
            </div>
            <div class="flexbox">
                <v-checkbox label="White" value="W" v-model="eth" :disabled="this.personal_data.Race_Ethnicity_MV.Race_Ethnicity > 1 || this.personal_data.Race_Ethnicity_MV.Race_Ethnicity != null" />
                <v-tooltip right v-model="show_tooltip_white" max-width="300px">
                    <template v-slot:activator="{}">
                        <v-btn v-click-outside="hide_white" @click="showTooltip('white')" icon aria-label="More information" style="display: inline;">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ this.tooltips.white }}</span>
                </v-tooltip>
            </div>
            <v-checkbox label="Prefer not to specify" v-model="eth" :disabled="this.personal_data.Race_Ethnicity_MV.Race_Ethnicity > 1 || this.personal_data.Race_Ethnicity_MV.Race_Ethnicity != null" />
        </v-container>
        <v-container>
            <h3 class="label">Self Identity</h3>
            <v-row>
                <v-col cols="12" sm="3">
                    <v-label aria-hidden="true">Pronoun</v-label>            
                </v-col>
                <v-col cols="12" sm="9">
                    <v-select v-model="selected_pronoun" outlined aria-label="Pronoun" clearable :items="sorted_pronouns" item-value="PK" item-text="Description" :value="this.personal_data.Preferred_Pronoun" />
                     <p class="instruction">Your pronoun preference will be displayed on the Adelphi website's public directory to help us address you properly.</p>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-switch label="Are you a person with a disability?" v-model="disabled" />
            <v-switch label="Are you a veteran with a disability?" v-model="disabled_vet" />
            <div class="flexbox">
                <v-switch label="Are you a Vietnam Era veteran?" v-model="vietnam_vet" />
                <v-tooltip right v-model="show_tooltip_vietnam" max-width="300px">
                    <template v-slot:activator="{}">
                        <v-btn v-click-outside="hide_vietnam" @click="showTooltip('vietnam')" icon aria-label="More information" style="display: inline;">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ this.tooltips.vietnam }}</span>
                </v-tooltip>
            </div>
        </v-container>
        <v-btn @click="this.saveAllChanges" color="#ffb500" :loading="loading" :disabled="loading" class="black--text v-btn v-btn--contained theme--light v-size--x-large">Submit Changes</v-btn>
        <v-snackbar v-model="data_saved">
            Your information has been saved.
            <v-btn @click="data_saved = false">Close</v-btn>
        </v-snackbar>
    </div>
    </div>
    </v-container>
</template>
<script>

import { mask } from "vue-the-mask";
import ClickOutside from "vue-click-outside"
import axios from 'axios'

export default {
    directives: {
        mask,
        ClickOutside
    },
   
    data: () => ({
        afterMounted: false,
        loading: false,
        data_saved: false,
        personal_data: null,
        mask: '###-###-####',
        show_tooltip_legal_name: false,
        show_tooltip_preferred_name: false,
        show_tooltip_hispanic: false,
        show_tooltip_white: false,
        show_tooltip_pacific: false,
        show_tooltip_asian: false,
        show_tooltip_black: false,
        show_tooltip_indigenous: false,
        show_tooltip_vietnam: false,
        show_preferred_name: false,
        prefixes: [
            'Mr.',
            'Mrs.',
            'Ms.',
            'Mx.',
            'Dr.',
            'Fr.',
            'Hon',
            'Rabbi',
            'Rev'
        ],
        suffixes: [
            'Esq.',
            'Jr.',
            'Sr.',
            'II',
            'III',
            'IV',
            'V',
            'VI'
        ],
        preferred_prefix: null,
        preferred_first: null,
        preferred_middle: null,
        preferred_last: null,
        preferred_suffix: null,
        preferred_mailing: false,
        preferred_pronouns: [],
        address1: null,
        address2: null,
        city: null,
        
        eth_w: false,
        eth_b: false,
        eth_a: false,
        eth_i: false,

        eth: [],
        
        disabled: false,
        disabled_vet: false,
        vietnam_vet: false,
        selected_state: null,
        selected_country: null,
        selected_pronoun: null,

        current_role: null,

        //state: [ 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'NY', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
        states: null,
        country: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombi', 'Comoros', 'Congo (Brazzaville)', 'Congo', 'Costa Rica', 'Cote d&apos;Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor (Timor Timur)', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia, The', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia and Montenegro', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'US', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'] ,
        
        //{key: 'NO', value: 'Choose Not to Specify'}, 
        tooltips: {
            legal_name: 'This is the legal name listed on your official W2 forms and may also be needed to ensure the accuracy of claims with benefits. If you change your legal name, please contact Human Resources.',
            pronoun: 'Your pronouns will be displayed on the public directory to help us address you properly.',
            preferred_name: 'The name that you commonly use which is different from your legal name.',
            vietnam: 'Having served between August 1964 and May 7, 1975.',
            hispanic: 'A person of Cuban, Mexican, Puerto Rican, South or Central American, or any other Spanish culture or origin regardless of race.',
            asian: 'A person having origins in the Far East, Southeast Asia, or the Indian subcontinent: including but not limited to Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand and Vietnam.',
            black: 'A person having origins in any of the black racial groups of Africa.',
            pacific: 'A person having origins in Hawaii, Guam or other Pacific Islands.',
            indigenous: 'A person having origins in the original peoples of North and South America (including Central America and Alaska), and who maintain tribal affiliation or community attachment.',
            white: 'A person having origins in Europe, the Middle East or North Africa.'
        },
    }),

    mounted() {
        /*
        // hide chatbot
        document.querySelectorAll('._admithub_embed-container').forEach(function(el) {
            el.style.display = 'none';
        });
        */

        axios.get('./remote-apis/user-api.php?cmd=cur_role')
            .then((response) => {
              this.current_role = response.data.cur_role;
              if (this.current_role == "student") {
                window.location = "./remote-apis/auth-redirect.php?goto=personal-student";
                return;
              }
            })
            .catch((err) => {
              window.console.log(err)
            })
      
        axios.get('./remote-apis/user-api.php?cmd=personal')
            .then(response => {
                this.personal_data = response.data.ROOT.Directory_SS
                this.home_phone = this.personal_data.Home_Number
                this.cell_phone = this.personal_data.Mobile_Number
                this.address1 = this.personal_data.Street_Address
                this.address2 = this.personal_data.Address_Line_2
                this.city = this.personal_data.City
                this.selected_state = this.personal_data.State
                this.selected_pronoun = this.personal_data.Preferred_Pronoun
                this.zip_code = this.personal_data.Zip
                this.selected_country = this.personal_data.Country
                this.emergency_name = this.personal_data.Emergency_Name
                this.emergency_phone = this.personal_data.Emergency_Number
                this.emergency_relationship = this.personal_data.Emergency_Relationship
                this.race_eth = this.personal_data.Race_Ethnicity_MV.Race_Ethnicity
                this.disabled = (this.personal_data.Disability === "1" ? true : false)
                this.disabled_vet = (this.personal_data.Disabled_Vet === "1" ? true : false)
                this.vietnam_vet = (this.personal_data.Vietnam_Vet === "1" ? true : false)
                // this.rave_signup = (this.personal_data.Rave_Alerts === "1" ? true : false)

                this.legal_prefix = this.personal_data.Prefix
                this.legal_suffix = this.personal_data.Suffix

                this.preferred_prefix = this.personal_data.Preferred_Prefix
                this.preferred_first = this.personal_data.Preferred_First
                this.preferred_middle = this.personal_data.Preferred_Middle
                this.preferred_last = this.personal_data.Preferred_Last
                this.preferred_suffix = this.personal_data.Preferred_Suffix
                this.preferred_mailing = (this.personal_data.Preferred_Name_Mailing === '1' ? true : false)

                // switch (this.preferred_suffix) {
                //     case 'Ii':
                //         this.preferred_suffix = 'II'
                //         break;
                //     case 'Iii':
                //         this.preferred_suffix = 'III'
                //         break
                //     case 'Iv':
                //         this.preferred_suffix = 'IV'
                //         break;
                // }

                this.show_preferred_name = ((this.preferred_prefix !== null || this.preferred_first !== null || this.preferred_middle != null || this.preferred_last !== null || this.preferred_suffix !== null) ? true : false)


                //window.console.log(this.personal_data.Preferred_Pronoun)
                this.afterMounted = true;
                
                if (Array.isArray(this.race_eth)) {
                    for (let i = 0; i < this.race_eth.length; i++) {
                        this.eth.push(this.race_eth[i])
                    }
                }else {
                    this.eth.push(this.race_eth)
                }
                //window.console.log(this.eth.length);
                // if (Array.isArray(this.race_eth)) {

                //     //const newLocal='this.eth_';
                //     window.console.log(this.race_eth.length)
                //     for (let i = 0; i < this.race_eth.length; i++) {
                //         let eth_obj = this.race_eth[i].toLowerCase()
                //         window.console.log(this.race_eth[i])
                //         window.console.log('this.eth_'+eth_obj+' = (this.race_eth[i] === "'+this.race_eth[i]+'" ? true : false)')
                        
                //         //eval(eth_obj+' = (this.race_eth[i] === "'+this.race_eth[i]+'" ? true : false)')
                //     }
                    
                // }else {
                //     window.console.log(this.race_eth)
                //     this.eth_w = (this.race_eth === 'W' ? true : false)
                //     this.eth_b = (this.race_eth === 'B' ? true : false)
                //     this.eth_a = (this.race_eth === 'A' ? true : false)
                // }
            })
            .catch(error => {
                window.console.error(error);
            })
        
        axios.get('./remote-apis/user-api.php?cmd=pgp')
            .then(response => {
                this.preferred_pronouns = response.data.ROOT.PREF_GENDER_PRONOUNS
                this.preferred_pronouns.push({pk: null, Description: ''})
            })
            .catch(error => {
                window.console.error(error)
            })

        axios.get('./remote-apis/user-api.php?cmd=st')
            .then(response => {
                this.states = response.data.ROOT.STATES
            })
            .catch(error => {
                window.console.error(error)
            })
    },

    computed: {
        sorted_pronouns: function() {
            function compare(a, b) {
                if (a.Description < b.Description) {
                    return -1
                }
                if (a.Description > b.Description) {
                    return 1
                }
                return 0
            }
            return this.preferred_pronouns.slice().sort(compare)
        }
    },

    methods: {

        sortPronouns: function(a, b) {
            if (a['Description'] === b['Description']) {
                return 0
            }else {
                return (a[0] < b[0]) ? -1 : 1
            }
        },

        saveAllChanges: function() {
            let self = this
            this.loading = true
            let formData = new FormData()
            formData.append('legal_prefix', this.legal_prefix)
            formData.append('legal_suffix', this.legal_suffix)
            formData.append('home_phone', this.home_phone)
            formData.append('cell_phone', this.cell_phone)
            formData.append('address1', this.address1)
            formData.append('address2', this.address2)
            formData.append('city', this.city)
            formData.append('zip', this.zip_code)
            formData.append('state', this.selected_state)
            formData.append('country', this.selected_country)
            formData.append('emergency_name', this.emergency_name)
            formData.append('emergency_relationship', this.emergency_relationship)
            formData.append('emergency_phone', this.emergency_phone)
            formData.append('pronoun', this.selected_pronoun)
            formData.append('ethnicity', this.eth)
            formData.append('preferred_prefix', this.preferred_prefix)
            formData.append('preferred_first', this.preferred_first)
            formData.append('preferred_middle', this.preferred_middle)
            formData.append('preferred_last', this.preferred_last)
            formData.append('preferred_suffix', this.preferred_suffix)
            formData.append('preferred_mailing', (this.preferred_mailing == true ? 1 : 0))
            formData.append('disabled', (this.disabled == true ? 1 : 0))
            formData.append('disabled_vet', (this.disabled_vet == true ? 1 : 0))
            formData.append('vietnam_vet', (this.vietnam_vet == true ? 1 : 0))
            // formData.append('rave_signup', (this.rave_signup === true ? 1 : 0))

            axios.post('./remote-apis/save-data.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    
                        window.console.log(response)
                        self.data_saved = true
                        self.loading = false
                   
                })
                .catch(error => {
                    return(
                    alert(error)
                    )
                })
            
        },

        showTooltip(name) {
            eval('this.show_tooltip_'+name+' = true')
        },

        hide_legal_name() {
            this.show_tooltip_legal_name = false
        },

        hide_preferred_name() {
            this.show_tooltip_preferred_name = false
        },
        
        hide_hispanic() {
            this.show_tooltip_hispanic = false
            //eval('this.show_tooltip_'+name+' =  false')
            // this.show_tooltip_legal_name = false
            // this.show_tooltip_preferred_name = false
            // this.show_tooltip_white = false
            // this.show_tooltip_pacific = false
            // this.show_tooltip_black = false
            // this.show_tooltip_indigenous = false
            // this.show_tooltip_vietnam = false
            // this.show_preferred_name = false
        },

        hide_asian() {
            this.show_tooltip_asian = false
        },

        hide_black() {
            this.show_tooltip_black = false
        },

        hide_pacific() {
            this.show_tooltip_pacific = false
        },

        hide_indigenous() {
            this.show_tooltip_indigenous = false
        },

        hide_white() {
            this.show_tooltip_white = false
        },

        hide_vietnam() {
            this.show_tooltip_vietnam = false
        }
    },


}
</script>